import React, { useCallback } from 'react';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { useTranslation } from 'common/i18n/hooks';
import { ButtonTheme } from 'common/components/button/constants';
import { ButtonReact } from 'common/components/button';
import { Translatable } from 'common/i18n';
import { initMixpanel } from 'common/report/tracking-setup';
import { useFeatureRollout } from 'common/hooks/useFeatureRollout';
import { FeatureRollouts } from 'common/report/util/feature-sampling';

// @ts-ignore
let mixpanel: any;
function trackAddButtonViewed(props: {
  hasBoardBreakdowns?: boolean;
}) {
  if (!mixpanel) {
    mixpanel = initMixpanel(PROJECT_3_MIXPANEL_TOKEN);
  }
  mixpanel.track("Global Filter Bar Add Button Viewed", props);
}
export function AddButton(props: {
  onClickAddFilter: () => void;
  onClickAddBreakdown: () => void;
  addFilterLabel?: Translatable;
  disabled?: boolean;
  hideAddBreakdowns?: boolean;
}) {
  const {
    print,
    t
  } = useTranslation();
  const hasBoardBreakdowns = useFeatureRollout(FeatureRollouts.board_breakdowns.name) && !props.hideAddBreakdowns;
  const onClickWithoutBoardBreakdowns = useCallback(() => {
    props.onClickAddFilter();
    trackAddButtonViewed({
      hasBoardBreakdowns
    });
  }, [props.onClickAddFilter, hasBoardBreakdowns]);
  return hasBoardBreakdowns ? <SelectReact theme={SelectTheme.Tertiary} icon={{
    leftIcon: "plus"
  }} iconOnly menuWidth={-1} disabled={props.disabled} onClick={() => trackAddButtonViewed({
    hasBoardBreakdowns
  })} sections={[{
    items: [{
      label: t("query-builder.filter"),
      icon: "filter",
      onSelect: props.onClickAddFilter
    }, {
      label: t("query-builder.breakdown"),
      icon: "segment",
      onSelect: props.onClickAddBreakdown
    }]
  }]} data-sentry-element="SelectReact" data-sentry-component="AddButton" data-sentry-source-file="add-button.tsx" /> : <ButtonReact theme={ButtonTheme.Tertiary} icon='plus' disabled={props.disabled} onClick={onClickWithoutBoardBreakdowns} data-sentry-element="ButtonReact" data-sentry-component="AddButton" data-sentry-source-file="add-button.tsx">
      {props.addFilterLabel ? print(props.addFilterLabel) : ""}
    </ButtonReact>;
}